import * as Sentry from '@sentry/react'
import { Integrations } from "@sentry/tracing"
import { graphql, useStaticQuery } from "gatsby"
import React, { useState, useEffect } from "react"
import CaretakersQuickAccessMenu from "../../atoms/caretakers-quick-access-menu/caretakers-quick-access-menu"
import CookiesToast from '../../../shared/components/molecules/cookies-toast/cookies-toast'
import Footer from "../../../shared/components/molecules/footer/footer"
import CaretakersHeader from "../../molecules/caretakers-header/caretakers-header"
import ShoppingModal from "../../../shared/components/molecules/shopping-modal/shopping-modal"
import ChatModal from "../../../shared/components/molecules/chat-modal/chat-modal"
import Cookies from 'universal-cookie'
import "./caretakers-layout.scss"

const CaretakersLayout = props => {

    Sentry.init({ integrations: [new Integrations.BrowserTracing()] });

    const { children, activeMenu } = props;
    const [activeShoppingModal, setActiveShoppingModal] = useState(false);
    const [activeCookiesToast, setActiveCookiesToast] = useState(false);

    const data = useStaticQuery(
        graphql`
            query {
            site {
                siteMetadata {
                title
                }
            }
        }
  `);

    useEffect(() => {
        const cookies = new Cookies();
        const cookiesAccepted = cookies.get('cookiesAccepted');
        if (!cookiesAccepted) {
            setActiveCookiesToast(true)
        }
    }, []);

    return (
        <>
            {activeShoppingModal &&
                <ShoppingModal setActiveShoppingModal={setActiveShoppingModal} />
            }
            {activeCookiesToast &&
                <CookiesToast setActiveCookiesToast={setActiveCookiesToast} />
            }
            <CaretakersHeader activeMenu={activeMenu} siteTitle={data.site.siteMetadata.title} setActiveShoppingModal={setActiveShoppingModal} />
            <CaretakersQuickAccessMenu setActiveShoppingModal={setActiveShoppingModal} />
            <ChatModal />
            <div>
                <main className="f-main-container">{children}</main>
                <Footer />
            </div>
        </>
    )
}

export default CaretakersLayout;